<template>
    <div class="center_loader">
        <v-progress-circular :size="45" indeterminate color="primary">
        </v-progress-circular>
    </div>
</template>
<script>

    export default {
        name: 'Loader',
        components: {},
        data() {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Common/Loader.vue